import {useEffect, useRef} from 'react';

export default function useBeforeUnloadConfirmation(enable: boolean) {
    const enabledRef = useRef(enable);
    enabledRef.current = enable;

    useEffect(() => {
        const onBeforeUnload = (event: BeforeUnloadEvent) => {
            if (enabledRef.current) {
                event.preventDefault();
                event.returnValue = '';
            }
        };

        window.addEventListener('beforeunload', onBeforeUnload);
        return () => window.removeEventListener('beforeunload', onBeforeUnload);
    }, []);
}
